import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { clearAnalyticsCookies, hasConsent, useCookieConsent } from '../tools/cookieConsent';
import { updateAnalyticsConsent } from '../tools/googleAnalytics';

export default function RouteAnalytics() {
    const location = useLocation();
    const allowed = useCookieConsent('analytics');
    const lastPath = useRef(null);

    useEffect(() => {
        // Re-read saved preferences and GPC before sending any measurement.
        const permitted = allowed && hasConsent('analytics');
        if (!permitted) clearAnalyticsCookies();
        updateAnalyticsConsent(permitted);

        // A preference change updates storage permission without another view.
        if (lastPath.current === location.pathname) return;
        lastPath.current = location.pathname;
        window.gtag('event', 'page_view', {
            page_path: location.pathname,
            page_location: window.location.origin + location.pathname,
            page_title: document.title,
        });
    }, [allowed, location.pathname]);

    return null;
}
